export const expenseTypes = {
  rent: 'Rent',
  food: 'Food',
  learningMaterials: 'Learning Materials',
  maintenance: 'Maintenance',
  other: 'Other',
  utilities: 'Utilities',
  subcontractorWages: 'Subcontractor Wages',
  principalWages: 'Principal Wages',
};

export interface AddExpenseItemState {
  expenseItem: ExpenseItem;
  isEdit: boolean;
}

export interface ExpenseItem {
  expenseTypeId: string;
  id: string;
  datePaid: string;
  amount: number;
  childUserId: string;
  notes: string;
  description: any;
  amountExpected: number;
  childCoverAmount: number;
  payTypeId: any;
  contributionTypeId: string;
  photoProof: any;
  feeTypeId: string;
}
